export const ValidationCotizacionSections = () => {
    return {
        form_datos_soli: {
            id_empresa: [ {required: true, message: 'Empresa Solicitante es requerido' } ],
            ruc: [ {required: true, message: 'RUC es requerido' } ],
            id_solicitante: [ {required: true, message: 'Usuario Solicitante es requerido' } ],
            id_servicio: [ {required: true, message: 'Tipo Servicio es requerido' } ],
            id_moneda: [ {required: true, message: 'Moneda es requerido' } ],
            id_forma_pago: [ {required: true, message: 'Condición de Pago es requerido' } ],
            id_vigencia_cotizacion: [ {required: true, message: 'Vigencia de Cotización es requerido' } ],
            id_tipo_servicio: [ {required: true, message: 'Tipo Documento es requerido' } ],
        },
    }
}
